module.exports = __webpack_public_path__ + "assets/img/8d9348710a412457a0c2b71158591f57.webp";